import posthog from "posthog-js";
import { getDesktopBridge } from "@/lib/desktop/bridge";

/**
 * Tags every event from the desktop app so its sessions can be told apart
 * from browser sessions. `posthog.reset()` clears super properties, so call
 * this again after identifying a user.
 */
export function registerDesktopAppContext() {
  const bridge = getDesktopBridge();
  if (!bridge) {
    return;
  }

  try {
    posthog.register({
      client_surface: "desktop_app",
      desktop_app_version: bridge.version ?? "unknown",
    });
  } catch {
    // Analytics must never block the app.
  }
}
